import React from 'react';
import Fade from '@material-ui/core/Fade';
import DirectionsSelector from '../DirectionsSelector';
import TagsSelector from '../TagsSelector';
import OwnershipSelector from '../OwnershipSelector';
import CalendarRangeSelector from '../CalendarRangeSelector';
import ExtensionSelector from '../ExtensionSelector';
import QueueSelector from '../QueueSelector';

import { Paper } from './styles';

interface Props {
  expanded: boolean;
}

export default function ExpandableHistoryCustomFilters(props: Props) {
  const { expanded } = props;

  return (
    <>
      {expanded && (
        <Fade in>
          <Paper>
            <OwnershipSelector />
            <DirectionsSelector />
            <TagsSelector />
            <CalendarRangeSelector />
            <QueueSelector />
            <ExtensionSelector />
          </Paper>
        </Fade>
      )}
    </>
  );
}
